import React from 'react'

import Card from 'react-bootstrap/Card'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'

import GemojiService from '../services/gemoji-service'
import IconFlexbox from './icon-flexbox.component'

class GemojiMenu extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = { emoteGroups: GemojiService.getAll() };
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <>
                <Tab.Container id="left-tabs-example" defaultActiveKey="icon-group-0">
                    <Nav variant="tabs" style={{margin: 0}}>
                        {
                            this.state.emoteGroups !== undefined ?
                            <>
                            {
                            this.state.emoteGroups.map((group, index) => {
                                return <Nav.Item key={index}>
                                    <Nav.Link key={index} eventKey={`icon-group-${index}`}>{group.icon}</Nav.Link>
                                </Nav.Item>
                            })
                            }
                            </>
                            : null
                        }
                    </Nav>
                    <Tab.Content>
                        {
                            this.state.emoteGroups !== undefined ?
                            <>
                            {
                                this.state.emoteGroups.map((group, index) => {
                                    return <Tab.Pane key={index} eventKey={`icon-group-${index}`}>
                                        <Card>
                                            <Card.Body>
                                                <IconFlexbox clickCallback={(x) => this.props.onEmojiClick(x)} emotes={group.emotes} categoryName={group.name} />
                                            </Card.Body>
                                        </Card>
                                        
                                    </Tab.Pane>
                                })
                            }
                            </>
                            : null
                        }
                    </Tab.Content>
                </Tab.Container>
            </>
        )
    }
}

export default GemojiMenu;